import React from 'react';
import './Hero.css';

const Hero = ({ t, scrollToSection }) => {
  return (
    <section id="home" className="hero">
      <div className="hero-content">
        <p className="hero-tagline">{t.hero.tagline}</p>
        <h1 className="hero-title">
          {t.hero.title}
          <span className="hero-title-highlight">{t.hero.titleHighlight}</span>
        </h1>
        <p className="hero-subtitle">{t.hero.subtitle}</p>
        <div className="hero-cta">
          <button className="btn btn-primary" onClick={() => scrollToSection('services')}>
            {t.hero.cta} →
          </button>
          <button className="btn btn-secondary" onClick={() => scrollToSection('contact')}>
            {t.hero.ctaSecondary}
          </button>
        </div>
      </div>
    </section>
  );
};

export default Hero;
